export const defaultRegionColor = "rgba(48, 64, 108, 0.3)";
export const highlightedRegionColor = "rgba(233, 85, 102, 0.4)";
export const playedRegionColor = "rgba(152,	83,	145, 0.6)";
